import { Warehouse, Plane, FileText } from "lucide-react";
import { Reveal, SectionTag } from "@/components/Reveal";

const LOGISTICS = [
  { icon: Warehouse, title: "Consolidation & Warehousing", desc: "Goods from multiple suppliers are received, inspected and consolidated at a single point, so you receive one clean shipment." },
  { icon: Plane, title: "Freight & Shipping", desc: "FCL, LCL and air freight booked after comparing rates across forwarders, with tracking from gate-in to arrival at your port." },
  { icon: FileText, title: "Export Documentation", desc: "Invoice, packing list, bill of lading, certificate of origin, inspection and health certificates prepared before dispatch." },
];

const INCOTERMS = ["EXW", "FOB", "CFR", "CIF", "DDP"];

export const Footprint = () => (
  <section id="markets" className="relative py-28 lg:py-40 bg-white" data-testid="footprint-section">
    <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
      <Reveal>
        <SectionTag index="07" label="Logistics & Export Execution" />
      </Reveal>
      <Reveal>
        <h2 className="font-display font-semibold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#0A1B33] max-w-3xl mb-20" data-testid="footprint-heading">
          Sourced across India. <span className="text-[#2E7FE0]">Shipped worldwide.</span>
        </h2>
      </Reveal>

      <div className="grid lg:grid-cols-12 gap-12 items-start">
        <Reveal className="lg:col-span-5">
          <div className="spotlight-frame relative rounded-2xl border border-[#2E7FE0]/15 overflow-hidden h-[380px]" data-testid="logistics-image-frame">
            <img
              src="https://images.unsplash.com/photo-1670121180530-cfcba4438038?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxjYXJnbyUyMHNoaXAlMjBwb3J0fGVufDB8fHx8MTc4NTM5MzI2NHww&ixlib=rb-4.1.0&q=85"
              alt="Container ship at export port"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#051024]/90 via-transparent to-transparent z-[3]" />
            <div className="absolute bottom-0 z-[4] p-8">
              <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#A1B0C8]">
                Logistics & export execution
              </p>
            </div>
          </div>
        </Reveal>
        <div className="lg:col-span-7">
          <div className="space-y-6">
            {LOGISTICS.map((l, i) => (
              <Reveal key={l.title} delay={i * 0.08}>
                <div className="flex gap-6 glass-panel rounded-2xl p-8" data-testid={`logistics-card-${i}`}>
                  <l.icon className="w-7 h-7 text-[#2E7FE0] shrink-0 mt-1" />
                  <div>
                    <h4 className="font-display font-semibold text-xl text-[#0A1B33] mb-2">{l.title}</h4>
                    <p className="text-[#54678A] text-sm leading-relaxed">{l.desc}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2} className="mt-8 flex flex-wrap items-center gap-3" data-testid="incoterms-strip">
            <span className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#54678A] mr-2">
              Incoterms supported
            </span>
            {INCOTERMS.map((t) => (
              <span
                key={t}
                className="font-display font-semibold text-[#0A1B33] bg-[#2E7FE0]/15 border border-[#2E7FE0]/40 rounded-full px-5 py-2 text-sm"
                data-testid={`incoterm-${t.toLowerCase()}`}
              >
                {t}
              </span>
            ))}
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
